import {Injectable} from '@angular/core';
import {CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';

import {Observable} from 'rxjs/Observable';
import { filter, map } from 'rxjs/operators';

import {AuthService} from './auth.service';
import {WebUtils} from '../utils/web.utils';
import { UserService } from '../services/user.service';
import { ObjectUtils } from '../utils/object.utils';
import { User } from '../../models/user';

@Injectable()
export class AdvertiserAppAuthGuard implements CanActivateChild {
  private readonly inactiveAccountPagePath = '/inactive-account';
  private readonly accountSettingsPagePath = '/account-settings';

  constructor(private auth: AuthService,
    private userService: UserService,
    private router: Router) {
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (this.shouldIgnoreUrl(state.url)) {
      return true;
    }

    // get company if ready,
    // otherwise, waiting for it being set in userService
    const companyId = this.userService.getCompanyId();

    if (!companyId) {
      return this.userService.companyId
        .pipe(
          filter(x => !!x),
          map(() => !this.isInactiveCompany())
        );
    }

    return !this.isInactiveCompany();
  }

  private shouldIgnoreUrl(url: string): boolean {
    return url.startsWith(this.inactiveAccountPagePath) || url.startsWith(this.accountSettingsPagePath);
  }

  private isInactiveCompany(): boolean {
    const advertiser = this.userService.getCurrentAdvertiser();
    const result = advertiser.inactive;

    if (result) {
      this.router.navigate(['/inactive-account'], { queryParams: { activeAccount: this.userService.getCompanyId() } });
    }

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/advertiser-app-auth.guard.ts